export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/social_media_marketing.e73fb70.svg";